<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>学生精准健康教育及风控信息平台</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">学生精准健康教育及风控信息平台</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        在当下互联网 + 的新时代，利用互联网、云计算、大数据等现代信息技术 + 健康管理理念，
        构建学涯无忧大学生精准健康教育及风险管控平台。平台是通过信息化手段建立健全在校学生电子健康档案，
        通过信息交互及大数据分析方法，预防学生健康事故的发生，
        降低学生意外死亡事件的发生概率，提升学生健康和体质水平，打造一流的学生管理平台。<br><br>
        <span class="con_text">特点 / 技术指标：</span>
        <br>
        1、平台通过收集学生入学体检、心理测评、体质监测等信息数据，结合日常学生管理工作的痕迹记录，建立学生电子健康档案。<br>
        2、新通过汇集学生的上网信息、一卡通消费信息反向绘制学生活动路径，利用大数据分析方法分析学生日常活动行为，<br>
        3、一预测和识别其风险因素，制定风险应对策略。<br>
        4、在日常的学生管理工作中，通过学校相关部门的工作协同，有针对性的开展学生风险预防工作。用信息化手段，辅助日常的学生管理工作。<br>
        5、学生管理工作的所有工作痕迹保存在学生电子健康档案中，使学生电子健康档案可共享、可追溯。<br><br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product4s.png" /></div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 80%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>